import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
let POITableColumnMappingService = class POITableColumnMappingService {
    POITableColumnMap = new BehaviorSubject(null);
    POITableColumnMapObservable = this.POITableColumnMap.asObservable();
    POITableItems = new BehaviorSubject(null);
    POITableItemsObservable = this.POITableItems.asObservable();
    createApplication = new BehaviorSubject(null);
    createApplicationObservable = this.createApplication.asObservable();
    constructor() {
    }
    setPOITableColumnMap(tableColumnMap) {
        this.POITableColumnMap.next(tableColumnMap);
    }
    setPOITableItems(tableItems) {
        this.POITableItems.next(tableItems);
    }
    createApplicationRequest(property) {
        this.createApplication.next(property);
    }
    static ctorParameters = () => [];
};
POITableColumnMappingService = __decorate([
    Injectable({
        providedIn: "root"
    })
], POITableColumnMappingService);
export { POITableColumnMappingService };
